import { useSupplierAuthStore } from './store/supplierAuth'

export type {
  Supplier,
  SupplierUser,
  SupplierProduct,
  SupplierStats,
  CreateSupplierData,
  UpdateSupplierData,
  CreateSupplierProductData,
  UpdateSupplierProductData,
  RussianBusinessDetails,
  ContactInfo,
} from './model/types'

export {
  SupplierStatus,
  SupplierUserRole,
  SupplierProductStatus,
  SupplierStatusLabels,
  SupplierUserRoleLabels,
  SupplierProductStatusLabels,
  getSupplierStatusColor,
  getSupplierProductStatusColor,
} from './model/types'

// Admin-facing supplier management contracts (используются modules/admin для
// approve/reject/CRUD в панели поставщиков). Публичный re-export вместо
// прямого импорта из `supplier/store`/`supplier/components` внутренностей.
export { useSupplierStore } from './store/supplier'
export { default as SupplierForm } from './components/SupplierForm.vue'

export function getSupplierRouteAccess() {
  const supplierAuthStore = useSupplierAuthStore()

  return {
    isAuthenticated: supplierAuthStore.isAuthenticated,
    user: supplierAuthStore.user,
    loadProfile: () => supplierAuthStore.loadProfile(),
  }
}

export async function ensureSupplierProfileLoaded() {
  const supplierAuthStore = useSupplierAuthStore()
  if (supplierAuthStore.isAuthenticated && !supplierAuthStore.user) {
    await supplierAuthStore.loadProfile()
  }
}
